import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const HashRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const { hash } = window.location;
        if (hash && hash.startsWith('#/')) {
            const next = `${hash.slice(1)}${window.location.search || ''}`;
            window.history.replaceState(null, '', next);
            navigate(next, { replace: true });
        }
    }, [navigate]);

    return null;
};

export default HashRedirect;
